import {replace, trimStart} from 'lodash';

const replaceMatchWith = params => match => {
  const paramId = trimStart(match, ':');
  return params[paramId];
};

export const composePath = (path, params) =>
  replace(path, /:[^/]*/g, replaceMatchWith(params));
